// import React from 'react'
// import Layout from '../components/layout'
// import { Line } from "react-chartjs-2";
// import { Bar } from "react-chartjs-2";
// import { Pie } from "react-chartjs-2";
// import { Doughnut } from "react-chartjs-2";
// import "chart.js/auto";

// function Analytics() {

//     const data = {
//         churnRate: {
//             labels: ["JAN", "FEB", "MAR", "APR"],
//             datasets: [
//                 {
//                     label: "Churn Rate",
//                     data: [2.5, 2.2, 2.8, 2.0],
//                     borderColor: "#c7852a",
//                     backgroundColor: "rgba(199, 133, 42, 0.2)",
//                     borderWidth: 2,
//                 },
//             ],
//         },
//         engagement: {
//             labels: ["Website Visits", "App Usage", "Support Tickets"],
//             datasets: [
//                 {
//                     label: "Engagement Metrics",
//                     data: [15000, 12000, 500],
//                     backgroundColor: "#c7852a",
                    
//                 },
//             ],
//         },
//         retentionRate: {
//             labels: ["Loans", "Investments", "Credit Cards", "Savings"],
//             datasets: [
//                 {
//                     label: "Retention Rate",
//                     data: [92, 85, 88, 90],
//                     backgroundColor: ["#c7852a", "#b4741f", "#a46315", "#8a5210"],
//                 },
//             ],
//         },
//     };
//     const barOptions = {
//         indexAxis: 'y',
//       };

//     return (
//         <Layout>
//             <div className="p-6 bg-[#F9F5F1] h-full flex flex-col items-center overflow-scroll hide-scrollbar">
//                 <h1 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold text-[#b4741f] mb-6">Customer Retention Report</h1>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-6xl">
//                     {/* Churn Rate Over Time */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae]">
//                         <h2 className="text-[#b4741f] font-bold">CHURN RATE OVER TIME</h2>
//                         <Line data={data.churnRate} />
//                     </div>

                    
//                     {/* Customer Engagement Metrics */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae]">
//                         <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} />
//                     </div>

//                     {/* Retention Rate by Product/Service */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] flex flex-col justify-evenly items-center">
//                         <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Pie data={data.retentionRate}  className="max-h-96 max-w-96"/>
//                     </div>
//                     {/* Retention Rate by Product/Service */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] flex flex-col justify-evenly items-center">
//                         <h2 className="text-[#b4741f] font-bold">RETENTION RATE BY PRODUCT/SERVICE</h2>
//                         <Doughnut data={data.retentionRate}  className="max-h-96 max-w-96"/>
//                     </div>
//                     {/* Customer Engagement Metrics */}
//                     <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] md:col-span-2 ">
//                         <h2 className="text-[#b4741f] font-bold">CUSTOMER ENGAGEMENT METRICS</h2>
//                         <Bar data={data.engagement} options={barOptions}/>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }

// export default Analytics






import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import { Line, Bar, Pie, Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import axios from "axios";
import { apiurl } from "../config/config";

function Analytics() {
  const [visits, setVisits] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const formatDate = (date) => date.toISOString().split("T")[0];

  const fetchData = async (start, end) => {
    try {
      setLoading(true);
      const [visitsRes, statsRes] = await Promise.all([
        axios.get(`${apiurl}/utils/page-visit/all`),
        axios.get(
          `${apiurl}/utils/page-visit/stats?startDate=${start}&endDate=${end}`
        ),
      ]);

      if (visitsRes.data.success) setVisits(visitsRes.data.summaries || []);
      if (statsRes.data.success) setStats(statsRes.data.stats || {});
    } catch (err) {
      console.error("Error fetching analytics:", err);
    } finally {
      setLoading(false);
    }
  };

  // load default (today)
  useEffect(() => {
    const today = formatDate(new Date());
    setStartDate(today);
    setEndDate(today);
    fetchData(today, today);
  }, []);

  const handleGetStats = () => {
    if (startDate && endDate) {
      fetchData(startDate, endDate);
    }
  };

  if (loading) {
    return (
      <Layout>
        <Container>
          <p className="text-center text-gray-500 mt-10">Loading analytics...</p>
        </Container>
      </Layout>
    );
  }

  // 🔹 Chart data
  const chartData = {
    line: {
      labels: visits.map((v) => v.pageUrl),
      datasets: [
        {
          label: "Total Visits",
          data: visits.map((v) => v.totalVisits),
          borderColor: "#c7852a",
          backgroundColor: "rgba(199, 133, 42, 0.2)",
          borderWidth: 2,
          tension: 0.4,
        },
        {
          label: "Unique Visitors",
          data: visits.map((v) => v.uniqueVisitors),
          borderColor: "#b4741f",
          backgroundColor: "rgba(180, 116, 31, 0.2)",
          borderWidth: 2,
          tension: 0.4,
        },
      ],
    },
    bar: {
      labels: visits.map((v) => v.pageUrl),
      datasets: [
        {
          label: "Unique Visitors",
          data: visits.map((v) => v.uniqueVisitors),
          backgroundColor: "#c7852a",
        },
      ],
    },
    pie: {
      labels: visits.map((v) => v.pageUrl),
      datasets: [
        {
          label: "Visits vs Unique Visitors",
          data: visits.map((v) => v.totalVisits - v.uniqueVisitors),
          backgroundColor: ["#c7852a", "#b4741f", "#a46315", "#8a5210"],
        },
      ],
    },
  };

  const barOptions = { indexAxis: "y" };

  return (
    <Layout>
      <Container overflow="overflow-scroll" className="py-8">
            <div className="p-6 bg-[#F9F5F1] rounded-xl shadow mx-auto">


        {/* 🔹 Date Filters */}
        <div className="flex flex-wrap items-end gap-4 mb-6">
          <div>
            <label className="block text-sm text-gray-600">Start Date</label>
            <input
              type="date"
              className="border rounded px-3 py-2"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-600">End Date</label>
            <input
              type="date"
              className="border rounded px-3 py-2"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <button
            onClick={handleGetStats}
            className="bg-[#b4741f] text-white px-4 py-2 rounded shadow hover:bg-[#9d631a]"
          >
            Get Stats
          </button>
        </div>

        {/* 🔹 Stats Summary */}
        {stats && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            <div className="p-4 bg-white rounded-lg shadow text-center border border-[#d8c9ae]">
              <h3 className="text-sm text-gray-500">Total Pages</h3>
              <p className="text-xl font-bold text-[#b4741f]">
                {stats.totalPages}
              </p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow text-center border border-[#d8c9ae]">
              <h3 className="text-sm text-gray-500">Total Visits</h3>
              <p className="text-xl font-bold text-[#b4741f]">
                {stats.totalVisits}
              </p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow text-center border border-[#d8c9ae]">
              <h3 className="text-sm text-gray-500">Unique Visitors</h3>
              <p className="text-xl font-bold text-[#b4741f]">
                {stats.totalUniqueVisitors}
              </p>
            </div>
            <div className="p-4 bg-white rounded-lg shadow text-center border border-[#d8c9ae]">
              <h3 className="text-sm text-gray-500">Last Visit</h3>
              <p className="text-sm text-gray-700">
                {stats.lastVisitedAt
                  ? new Date(stats.lastVisitedAt).toLocaleString()
                  : "N/A"}
              </p>
            </div>
          </div>
        )}
      </div>
        {/* Page Visit Table */}
        <div className="p-6 bg-[#F9F5F1] mt-10 rounded-xl shadow mx-auto">
          <h1 className="text-2xl font-bold mb-6 text-[#b4741f]">
            📊 Page Visit Analytics
          </h1>
          <div className="overflow-x-auto bg-white rounded-lg shadow border border-[#d8c9ae]">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Page URL
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Total Visits
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Unique Visitors
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Last Visited
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {visits.length ? (
                  visits.map((visit) => (
                    <tr key={visit._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 text-blue-600 font-medium">
                        {visit.pageUrl}
                      </td>
                      <td className="px-6 py-4">{visit.totalVisits}</td>
                      <td className="px-6 py-4">{visit.uniqueVisitors}</td>
                      <td className="px-6 py-4 text-sm text-gray-500">
                        {visit.lastVisitedAt
                          ? new Date(visit.lastVisitedAt).toLocaleString()
                          : "N/A"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="px-6 py-4 text-center text-gray-400"
                    >
                      No page visits recorded yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Charts Section */}
        <div className="p-6 bg-[#F9F5F1] mt-10 rounded-xl shadow mx-auto">
          <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-[#b4741f] mb-6 text-center">
            Customer Analytics Charts
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-4 rounded-xl shadow border border-[#d8c9ae]">
              <h2 className="text-[#b4741f] font-bold mb-2">
                Total vs Unique Visits (Line)
              </h2>
              <Line data={chartData.line} />
            </div>

            <div className="bg-white p-4 rounded-xl shadow border border-[#d8c9ae]">
              <h2 className="text-[#b4741f] font-bold mb-2">
                Unique Visitors (Bar)
              </h2>
              <Bar data={chartData.bar} />
            </div>

            <div className="bg-white p-4 rounded-xl shadow border border-[#d8c9ae] flex flex-col items-center justify-center">
              <h2 className="text-[#b4741f] font-bold mb-2">
                Visits Distribution (Pie)
              </h2>
              <Pie data={chartData.pie} className="max-h-96 max-w-96" />
            </div>

            <div className="bg-white p-4 rounded-xl shadow border border-[#d8c9ae] flex flex-col items-center justify-center">
              <h2 className="text-[#b4741f] font-bold mb-2">
                Visits Distribution (Doughnut)
              </h2>
              <Doughnut data={chartData.pie} className="max-h-96 max-w-96" />
            </div>

            <div className="bg-white p-4 rounded-xl shadow border border-[#d8c9ae] md:col-span-2">
              <h2 className="text-[#b4741f] font-bold mb-2">
                Horizontal Bar: Unique Visitors
              </h2>
              <Bar data={chartData.bar} options={barOptions} />
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
}

export default Analytics;
